import React, {JSX, ReactNode} from 'react';
import {Autocomplete, Paper, TextField, Typography} from '@mui/material';

interface AutocompleteFieldProps<T> {
    value?: T | null;
    title?: string;
    name: string;
    placeholder?: string;
    options: T[];
    onChange: (value: T | null) => void;
    getOptionLabel: (option: T) => string;
    isOptionEqualToValue: (option: T, value: T | null) => boolean;
    required?: boolean;
    icon?: ReactNode;
    disabled?: boolean;
}

function AutocompleteField<T>(
    {value, title, name, placeholder, options, onChange, getOptionLabel, isOptionEqualToValue, required, disabled}: AutocompleteFieldProps<T>): JSX.Element {

    const handleSelection = ( event: React.SyntheticEvent<Element, Event>, value: T | null ) => {
        if (onChange) {
            onChange(value);
        }
    };

    return (
        <>
            {title && (
                <Typography variant="body2" gutterBottom>
                    {title}
                </Typography>
            )}
            <Autocomplete
                sx={{
                    backgroundColor: 'background.paper',
                    borderRadius: '8px',
                }}
                value={value}
                options={options}
                disabled={disabled}
                onChange={handleSelection}
                getOptionLabel={getOptionLabel}
                isOptionEqualToValue={isOptionEqualToValue}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        name={name}
                        required={required}
                        placeholder={placeholder}
                    />
                )}
                slots={{
                    paper: (props: any) => (
                        <Paper {...props} sx={{ borderRadius: "8px" }} />
                    )
                }}
            />
        </>
    );
}

export default AutocompleteField;
